/* hume-final.js - Buy Now -> scroll to the Cyclist Pack hero; iconlist phone swiper (Leo 2026-09-07) */
(function () {
  function target() {
    return document.querySelector('.helios-desktop #helios-desktop-host .hd-hero') || document.querySelector('.helios-desktop #helios-desktop-host') || document.querySelector('.exp5-root .exp5-gallery') || document.querySelector('.exp5-root');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.humetop .buy-btn, .humetop .hero-btn, .humetop .scroll-down');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var t = target(); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
  function initSwipe(root) {
    var screens = [].slice.call(root.querySelectorAll('.hf-swipe__screen'));
    var dots = [].slice.call(root.querySelectorAll('[data-hf-dot]'));
    var names = dots.map(function (d) { return d.getAttribute('aria-label'); });
    var n = dots.length, i = 0;
    function go(k) {
      i = (k + n) % n;
      screens.forEach(function (s) { s.hidden = String(i) !== s.getAttribute('data-hf-i'); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      var a = root.querySelector('[data-hf-n]'), b = root.querySelector('[data-hf-name]');
      if (a) a.textContent = i + 1; if (b) b.textContent = names[i];
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    var p = root.querySelector('[data-hf-prev]'), q = root.querySelector('[data-hf-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (q) q.addEventListener('click', function () { go(i + 1); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); }, { passive: true });
    go(0);
  }
  function boot() { document.querySelectorAll('[data-hf-swipe]').forEach(initSwipe); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
